import { useState } from "react";

const COLORS = {
  bg: "#FDF6F0",
  card: "#FFFFFF",
  primary: "#C4563A",
  primaryLight: "#E8836A",
  primaryDark: "#9E3E27",
  accent: "#E8C4A0",
  accentWarm: "#F0A070",
  text: "#2C1810",
  textMuted: "#8B6055",
  textLight: "#C49080",
  surface: "#FAF0E8",
  border: "#F0D8C8",
  match: "#FF6B8A",
  online: "#5CB85C",
};

const profiles = [
  { id: 1, name: "Amara", age: 27, location: "London, UK", distance: "2 miles", bio: "Nigerian-British. Lover of Afrobeats, jollof rice debates & sunset walks. Looking for someone who celebrates all of me.", tags: ["Afrobeats", "Foodie", "Travel"], verified: true, online: true, bg: "linear-gradient(135deg, #C4563A 0%, #8B3A6B 100%)", initials: "AM" },
  { id: 2, name: "Ravi", age: 31, location: "Birmingham, UK", distance: "5 miles", bio: "British-Indian, software engineer by day, chef by night. My mum's biryani recipe is sacred. Looking for real connection.", tags: ["Cooking", "Music", "Hiking"], verified: true, online: false, bg: "linear-gradient(135deg, #2C7BB6 0%, #1A5276 100%)", initials: "RV" },
  { id: 3, name: "Leila", age: 25, location: "Coventry, UK", distance: "1 mile", bio: "Iranian-British. Artist & dreamer. I paint feelings, not pictures. Let's explore culture together.", tags: ["Art", "Poetry", "Coffee"], verified: false, online: true, bg: "linear-gradient(135deg, #7D3C98 0%, #C0392B 100%)", initials: "LE" },
  { id: 4, name: "Marcus", age: 29, location: "Manchester, UK", distance: "8 miles", bio: "Jamaican heritage, Manchester raised. Music producer. Looking for someone who loves authentically.", tags: ["Music", "Films", "Gym"], verified: true, online: true, bg: "linear-gradient(135deg, #1E8449 0%, #117A65 100%)", initials: "MA" },
];

const matches = [
  { id: 1, name: "Amara", age: 27, matchPercent: 94, online: true, bg: "linear-gradient(135deg, #C4563A 0%, #8B3A6B 100%)", initials: "AM", lastSeen: "now", unread: 2 },
  { id: 2, name: "Leila", age: 25, matchPercent: 88, online: true, bg: "linear-gradient(135deg, #7D3C98 0%, #C0392B 100%)", initials: "LE", lastSeen: "5m ago", unread: 0 },
  { id: 3, name: "Sofia", age: 28, matchPercent: 82, online: false, bg: "linear-gradient(135deg, #E67E22 0%, #D35400 100%)", initials: "SO", lastSeen: "2h ago", unread: 1 },
  { id: 4, name: "Priya", age: 26, matchPercent: 79, online: false, bg: "linear-gradient(135deg, #E91E8C 0%, #C2185B 100%)", initials: "PR", lastSeen: "1d ago", unread: 0 },
];

const messages = [
  { id: 1, from: "them", text: "Hey! I loved your profile, especially the part about jollof rice debates 😄", time: "10:24 AM" },
  { id: 2, from: "me", text: "Haha thank you! It's a very serious topic in our household 😂 How are you?", time: "10:26 AM" },
  { id: 3, from: "them", text: "I'm great! So what's your take — Nigerian or Ghanaian jollof?", time: "10:27 AM" },
  { id: 4, from: "me", text: "Oh you're going straight for the controversial question 😅 Nigerian, always. No debate needed!", time: "10:29 AM" },
  { id: 5, from: "them", text: "Haha! Bold. I respect it. Maybe we could settle it over dinner sometime? 🍽️", time: "10:31 AM" },
];

function Avatar({ profile, size = 56 }) {
  return (
    <div style={{
      width: size, height: size, borderRadius: "50%",
      background: profile.bg, display: "flex", alignItems: "center",
      justifyContent: "center", fontFamily: "'Playfair Display', serif",
      fontSize: size * 0.32, fontWeight: 700, color: "#fff",
      flexShrink: 0, position: "relative",
      boxShadow: "0 4px 12px rgba(0,0,0,0.15)"
    }}>
      {profile.initials}
      {profile.online && (
        <div style={{
          position: "absolute", bottom: 2, right: 2,
          width: size * 0.22, height: size * 0.22,
          borderRadius: "50%", background: COLORS.online,
          border: "2px solid #fff"
        }} />
      )}
    </div>
  );
}

function HeartIcon({ filled = false, size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill={filled ? COLORS.match : "none"} stroke={filled ? COLORS.match : "currentColor"} strokeWidth="2">
      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
    </svg>
  );
}

function StarIcon({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
    </svg>
  );
}

function XIcon({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
      <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
    </svg>
  );
}

function SendIcon({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
      <path d="M22 2L11 13M22 2L15 22l-4-9-9-4 20-7z"/>
    </svg>
  );
}

// ─── LOGIN SCREEN ────────────────────────────────────────────
function LoginScreen({ onLogin, goRegister }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [focused, setFocused] = useState(null);

  return (
    <div style={{ flex: 1, display: "flex", flexDirection: "column", background: COLORS.bg, overflowY: "auto" }}>
      {/* Hero */}
      <div style={{
        background: `linear-gradient(160deg, ${COLORS.primaryDark} 0%, ${COLORS.primary} 50%, ${COLORS.accentWarm} 100%)`,
        padding: "56px 28px 40px", textAlign: "center", position: "relative", overflow: "hidden"
      }}>
        <div style={{ position: "absolute", top: -40, right: -40, width: 160, height: 160, borderRadius: "50%", background: "rgba(255,255,255,0.06)" }} />
        <div style={{ position: "absolute", bottom: -20, left: -30, width: 120, height: 120, borderRadius: "50%", background: "rgba(255,255,255,0.04)" }} />
        <div style={{ fontSize: 48, marginBottom: 8 }}>💕</div>
        <div style={{ fontFamily: "'Playfair Display', serif", fontSize: 28, fontWeight: 700, color: "#fff", marginBottom: 6, letterSpacing: "-0.3px" }}>Beyond Colour</div>
        <div style={{ fontFamily: "'Playfair Display', serif", fontSize: 14, color: "rgba(255,255,255,0.75)", fontStyle: "italic" }}>Where your story meets someone who understands it</div>
      </div>

      {/* Form */}
      <div style={{ padding: "32px 24px", flex: 1 }}>
        <div style={{ fontFamily: "'Playfair Display', serif", fontSize: 22, fontWeight: 700, color: COLORS.text, marginBottom: 24 }}>Welcome back ✨</div>

        {["email", "password"].map((field) => (
          <div key={field} style={{ marginBottom: 16 }}>
            <label style={{ fontFamily: "Georgia, serif", fontSize: 12, color: COLORS.textMuted, textTransform: "uppercase", letterSpacing: "0.8px", display: "block", marginBottom: 6 }}>
              {field === "email" ? "Email Address" : "Password"}
            </label>
            <input
              type={field}
              placeholder={field === "email" ? "your@email.com" : "••••••••"}
              value={field === "email" ? email : password}
              onChange={e => field === "email" ? setEmail(e.target.value) : setPassword(e.target.value)}
              onFocus={() => setFocused(field)}
              onBlur={() => setFocused(null)}
              style={{
                width: "100%", padding: "14px 16px", borderRadius: 12,
                border: `2px solid ${focused === field ? COLORS.primary : COLORS.border}`,
                background: focused === field ? "#fff" : COLORS.surface,
                fontFamily: "Georgia, serif", fontSize: 15, color: COLORS.text,
                outline: "none", boxSizing: "border-box",
                transition: "all 0.2s ease"
              }}
            />
          </div>
        ))}

        <div style={{ textAlign: "right", marginBottom: 24 }}>
          <span style={{ fontFamily: "Georgia, serif", fontSize: 13, color: COLORS.primary, cursor: "pointer" }}>Forgot password?</span>
        </div>

        <button onClick={onLogin} style={{
          width: "100%", padding: "16px", borderRadius: 14, border: "none",
          background: `linear-gradient(135deg, ${COLORS.primary}, ${COLORS.primaryLight})`,
          color: "#fff", fontFamily: "'Playfair Display', serif", fontSize: 17, fontWeight: 700,
          cursor: "pointer", boxShadow: "0 6px 20px rgba(196,86,58,0.35)", letterSpacing: "0.3px"
        }}>Sign In</button>

        <div style={{ marginTop: 20, textAlign: "center" }}>
          <span style={{ fontFamily: "Georgia, serif", fontSize: 14, color: COLORS.textMuted }}>Don't have an account? </span>
          <span onClick={goRegister} style={{ fontFamily: "Georgia, serif", fontSize: 14, color: COLORS.primary, fontWeight: 600, cursor: "pointer" }}>Join free</span>
        </div>

        <div style={{ marginTop: 28, display: "flex", alignItems: "center", gap: 12 }}>
          <div style={{ flex: 1, height: 1, background: COLORS.border }} />
          <span style={{ fontFamily: "Georgia, serif", fontSize: 12, color: COLORS.textLight }}>or continue with</span>
          <div style={{ flex: 1, height: 1, background: COLORS.border }} />
        </div>

        <div style={{ marginTop: 16, display: "flex", gap: 12 }}>
          {["🍎 Apple", "🔵 Google"].map(label => (
            <button key={label} style={{
              flex: 1, padding: "13px", borderRadius: 12,
              border: `1.5px solid ${COLORS.border}`, background: "#fff",
              fontFamily: "Georgia, serif", fontSize: 14, color: COLORS.text,
              cursor: "pointer"
            }}>{label}</button>
          ))}
        </div>
      </div>
    </div>
  );
}

// ─── REGISTER SCREEN ─────────────────────────────────────────
function RegisterScreen({ onRegister, goLogin }) {
  const [step, setStep] = useState(1);
  const [name, setName] = useState("");
  const [dob, setDob] = useState("");
  const [gender, setGender] = useState("");
  const [seeking, setSeeking] = useState("");

  const genders = ["Man", "Woman", "Non-binary", "Couple"];
  const seekings = ["Men", "Women", "Everyone"];

  return (
    <div style={{ flex: 1, display: "flex", flexDirection: "column", background: COLORS.bg, overflowY: "auto" }}>
      <div style={{
        background: `linear-gradient(160deg, ${COLORS.primaryDark}, ${COLORS.primary})`,
        padding: "48px 24px 28px"
      }}>
        <div style={{ fontFamily: "'Playfair Display', serif", fontSize: 24, fontWeight: 700, color: "#fff", marginBottom: 4 }}>Create your story 🌍</div>
        <div style={{ fontFamily: "Georgia, serif", fontSize: 13, color: "rgba(255,255,255,0.7)" }}>Step {step} of 2 — {step === 1 ? "About you" : "Your preferences"}</div>
        <div style={{ marginTop: 16, display: "flex", gap: 6 }}>
          {[1, 2].map(s => (
            <div key={s} style={{
              flex: 1, height: 4, borderRadius: 2,
              background: s <= step ? "rgba(255,255,255,0.9)" : "rgba(255,255,255,0.25)"
            }} />
          ))}
        </div>
      </div>

      <div style={{ padding: "28px 24px", flex: 1 }}>
        {step === 1 ? (
          <>
            <div style={{ marginBottom: 20 }}>
              <label style={{ fontFamily: "Georgia, serif", fontSize: 12, color: COLORS.textMuted, textTransform: "uppercase", letterSpacing: "0.8px", display: "block", marginBottom: 6 }}>Your Name</label>
              <input value={name} onChange={e => setName(e.target.value)} placeholder="What should we call you?" style={{
                width: "100%", padding: "14px 16px", borderRadius: 12,
                border: `2px solid ${COLORS.border}`, background: COLORS.surface,
                fontFamily: "Georgia, serif", fontSize: 15, color: COLORS.text,
                outline: "none", boxSizing: "border-box"
              }} />
            </div>
            <div style={{ marginBottom: 20 }}>
              <label style={{ fontFamily: "Georgia, serif", fontSize: 12, color: COLORS.textMuted, textTransform: "uppercase", letterSpacing: "0.8px", display: "block", marginBottom: 6 }}>Date of Birth</label>
              <input type="date" value={dob} onChange={e => setDob(e.target.value)} style={{
                width: "100%", padding: "14px 16px", borderRadius: 12,
                border: `2px solid ${COLORS.border}`, background: COLORS.surface,
                fontFamily: "Georgia, serif", fontSize: 15, color: COLORS.text,
                outline: "none", boxSizing: "border-box"
              }} />
            </div>
            <div style={{ marginBottom: 28 }}>
              <label style={{ fontFamily: "Georgia, serif", fontSize: 12, color: COLORS.textMuted, textTransform: "uppercase", letterSpacing: "0.8px", display: "block", marginBottom: 10 }}>I am a...</label>
              <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                {genders.map(g => (
                  <button key={g} onClick={() => setGender(g)} style={{
                    padding: "10px 18px", borderRadius: 20,
                    border: `2px solid ${gender === g ? COLORS.primary : COLORS.border}`,
                    background: gender === g ? COLORS.primary : "#fff",
                    color: gender === g ? "#fff" : COLORS.text,
                    fontFamily: "Georgia, serif", fontSize: 14, cursor: "pointer", transition: "all 0.15s"
                  }}>{g}</button>
                ))}
              </div>
            </div>
            <button onClick={() => setStep(2)} style={{
              width: "100%", padding: "16px", borderRadius: 14, border: "none",
              background: `linear-gradient(135deg, ${COLORS.primary}, ${COLORS.primaryLight})`,
              color: "#fff", fontFamily: "'Playfair Display', serif", fontSize: 17, fontWeight: 700,
              cursor: "pointer", boxShadow: "0 6px 20px rgba(196,86,58,0.3)"
            }}>Continue →</button>
          </>
        ) : (
          <>
            <div style={{ marginBottom: 28 }}>
              <label style={{ fontFamily: "Georgia, serif", fontSize: 12, color: COLORS.textMuted, textTransform: "uppercase", letterSpacing: "0.8px", display: "block", marginBottom: 10 }}>I'm looking for...</label>
              <div style={{ display: "flex", gap: 10 }}>
                {seekings.map(s => (
                  <button key={s} onClick={() => setSeeking(s)} style={{
                    flex: 1, padding: "12px 8px", borderRadius: 14,
                    border: `2px solid ${seeking === s ? COLORS.primary : COLORS.border}`,
                    background: seeking === s ? COLORS.primary : "#fff",
                    color: seeking === s ? "#fff" : COLORS.text,
                    fontFamily: "Georgia, serif", fontSize: 14, cursor: "pointer", transition: "all 0.15s"
                  }}>{s}</button>
                ))}
              </div>
            </div>

            <div style={{
              background: `linear-gradient(135deg, ${COLORS.surface}, #fff)`,
              border: `1.5px solid ${COLORS.border}`, borderRadius: 16, padding: 20, marginBottom: 28
            }}>
              <div style={{ fontSize: 20, marginBottom: 8 }}>🌍</div>
              <div style={{ fontFamily: "'Playfair Display', serif", fontSize: 16, fontWeight: 700, color: COLORS.text, marginBottom: 6 }}>Built for all cultures & backgrounds</div>
              <div style={{ fontFamily: "Georgia, serif", fontSize: 13, color: COLORS.textMuted, lineHeight: 1.6 }}>Beyond Colour Dating celebrates diversity. Your heritage, culture and identity are welcome here — fully and completely.</div>
            </div>

            <div style={{ display: "flex", gap: 10 }}>
              <button onClick={() => setStep(1)} style={{
                flex: 0, padding: "16px 20px", borderRadius: 14,
                border: `2px solid ${COLORS.border}`, background: "#fff",
                fontFamily: "Georgia, serif", fontSize: 15, color: COLORS.textMuted, cursor: "pointer"
              }}>←</button>
              <button onClick={onRegister} style={{
                flex: 1, padding: "16px", borderRadius: 14, border: "none",
                background: `linear-gradient(135deg, ${COLORS.primary}, ${COLORS.primaryLight})`,
                color: "#fff", fontFamily: "'Playfair Display', serif", fontSize: 17, fontWeight: 700,
                cursor: "pointer", boxShadow: "0 6px 20px rgba(196,86,58,0.3)"
              }}>Create My Profile 💕</button>
            </div>
          </>
        )}

        <div style={{ marginTop: 20, textAlign: "center" }}>
          <span style={{ fontFamily: "Georgia, serif", fontSize: 14, color: COLORS.textMuted }}>Already have an account? </span>
          <span onClick={goLogin} style={{ fontFamily: "Georgia, serif", fontSize: 14, color: COLORS.primary, fontWeight: 600, cursor: "pointer" }}>Sign in</span>
        </div>
      </div>
    </div>
  );
}

// ─── DISCOVER SCREEN ─────────────────────────────────────────
function DiscoverScreen() {
  const [current, setCurrent] = useState(0);
  const [, setLiked] = useState([]);
  const [, setPassed] = useState([]);
  const [swipeAnim, setSwipeAnim] = useState(null);
  const [showMatch, setShowMatch] = useState(false);

  const profile = profiles[current % profiles.length];

  const swipe = (dir) => {
    setSwipeAnim(dir);
    setTimeout(() => {
      if (dir === "right") {
        setLiked(l => [...l, profile.id]);
        if (Math.random() > 0.4) setShowMatch(true);
      } else {
        setPassed(p => [...p, profile.id]);
      }
      setCurrent(c => c + 1);
      setSwipeAnim(null);
    }, 300);
  };

  return (
    <div style={{ flex: 1, display: "flex", flexDirection: "column", background: COLORS.bg, overflow: "hidden" }}>
      {/* Header */}
      <div style={{ padding: "16px 20px 8px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <div>
          <div style={{ fontFamily: "'Playfair Display', serif", fontSize: 22, fontWeight: 700, color: COLORS.text }}>Discover 🌍</div>
          <div style={{ fontFamily: "Georgia, serif", fontSize: 12, color: COLORS.textMuted }}>People near Coventry</div>
        </div>
        <div style={{
          background: COLORS.surface, borderRadius: 20, padding: "8px 14px",
          border: `1.5px solid ${COLORS.border}`, display: "flex", alignItems: "center", gap: 6
        }}>
          <span style={{ fontSize: 14 }}>🎯</span>
          <span style={{ fontFamily: "Georgia, serif", fontSize: 13, color: COLORS.textMuted }}>10 mi</span>
        </div>
      </div>

      {/* Card */}
      <div style={{ flex: 1, padding: "8px 16px", display: "flex", alignItems: "center" }}>
        <div style={{
          width: "100%", borderRadius: 24, overflow: "hidden",
          boxShadow: "0 16px 48px rgba(196,86,58,0.18), 0 4px 16px rgba(0,0,0,0.08)",
          transform: swipeAnim === "right" ? "translateX(100px) rotate(12deg)" : swipeAnim === "left" ? "translateX(-100px) rotate(-12deg)" : "translateX(0) rotate(0)",
          transition: "transform 0.3s ease", background: "#fff"
        }}>
          {/* Profile top */}
          <div style={{
            background: profile.bg, height: 240, display: "flex",
            alignItems: "center", justifyContent: "center", position: "relative"
          }}>
            <div style={{ fontFamily: "'Playfair Display', serif", fontSize: 80, fontWeight: 700, color: "rgba(255,255,255,0.9)" }}>
              {profile.initials}
            </div>
            {profile.verified && (
              <div style={{
                position: "absolute", top: 16, right: 16, background: "rgba(255,255,255,0.95)",
                borderRadius: 20, padding: "4px 10px", display: "flex", alignItems: "center", gap: 4
              }}>
                <span style={{ fontSize: 12 }}>✓</span>
                <span style={{ fontFamily: "Georgia, serif", fontSize: 11, color: COLORS.primary, fontWeight: 600 }}>Verified</span>
              </div>
            )}
            {profile.online && (
              <div style={{
                position: "absolute", top: 16, left: 16, background: "rgba(92,184,92,0.9)",
                borderRadius: 20, padding: "4px 10px"
              }}>
                <span style={{ fontFamily: "Georgia, serif", fontSize: 11, color: "#fff", fontWeight: 600 }}>● Online</span>
              </div>
            )}
          </div>

          {/* Info */}
          <div style={{ padding: "20px 20px 16px" }}>
            <div style={{ display: "flex", alignItems: "baseline", gap: 8, marginBottom: 4 }}>
              <span style={{ fontFamily: "'Playfair Display', serif", fontSize: 22, fontWeight: 700, color: COLORS.text }}>{profile.name}</span>
              <span style={{ fontFamily: "Georgia, serif", fontSize: 18, color: COLORS.textMuted }}>{profile.age}</span>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 4, marginBottom: 12 }}>
              <span style={{ fontSize: 13 }}>📍</span>
              <span style={{ fontFamily: "Georgia, serif", fontSize: 13, color: COLORS.textMuted }}>{profile.location} · {profile.distance}</span>
            </div>
            <div style={{ fontFamily: "Georgia, serif", fontSize: 14, color: COLORS.text, lineHeight: 1.6, marginBottom: 14 }}>{profile.bio}</div>
            <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
              {profile.tags.map(t => (
                <span key={t} style={{
                  padding: "5px 12px", borderRadius: 16,
                  background: COLORS.surface, border: `1.5px solid ${COLORS.border}`,
                  fontFamily: "Georgia, serif", fontSize: 12, color: COLORS.textMuted
                }}>#{t}</span>
              ))}
            </div>
          </div>

          {/* Action buttons */}
          <div style={{ padding: "8px 20px 20px", display: "flex", justifyContent: "center", gap: 20 }}>
            <button onClick={() => swipe("left")} style={{
              width: 58, height: 58, borderRadius: "50%", border: `2px solid ${COLORS.border}`,
              background: "#fff", display: "flex", alignItems: "center", justifyContent: "center",
              cursor: "pointer", boxShadow: "0 4px 12px rgba(0,0,0,0.08)", color: "#e74c3c"
            }}><XIcon size={22} /></button>
            <button style={{
              width: 48, height: 48, borderRadius: "50%", border: `2px solid ${COLORS.border}`,
              background: "#fff", display: "flex", alignItems: "center", justifyContent: "center",
              cursor: "pointer", boxShadow: "0 4px 12px rgba(0,0,0,0.08)", color: "#f39c12", marginTop: 4
            }}><StarIcon size={18} /></button>
            <button onClick={() => swipe("right")} style={{
              width: 58, height: 58, borderRadius: "50%", border: "none",
              background: `linear-gradient(135deg, ${COLORS.match}, #e91e8c)`,
              display: "flex", alignItems: "center", justifyContent: "center",
              cursor: "pointer", boxShadow: "0 6px 20px rgba(255,107,138,0.4)"
            }}><HeartIcon filled size={24} /></button>
          </div>
        </div>
      </div>

      {/* Match popup */}
      {showMatch && (
        <div style={{
          position: "absolute", inset: 0, background: "rgba(0,0,0,0.7)",
          display: "flex", alignItems: "center", justifyContent: "center",
          zIndex: 100, padding: 24
        }}>
          <div style={{
            background: "#fff", borderRadius: 24, padding: 32, textAlign: "center",
            boxShadow: "0 24px 64px rgba(0,0,0,0.3)", maxWidth: 320, width: "100%"
          }}>
            <div style={{ fontSize: 48, marginBottom: 8 }}>💕</div>
            <div style={{ fontFamily: "'Playfair Display', serif", fontSize: 26, fontWeight: 700, color: COLORS.primary, marginBottom: 8 }}>It's a Match!</div>
            <div style={{ fontFamily: "Georgia, serif", fontSize: 15, color: COLORS.textMuted, marginBottom: 24 }}>You and {profile.name} liked each other. Start a conversation!</div>
            <button onClick={() => setShowMatch(false)} style={{
              width: "100%", padding: "14px", borderRadius: 14, border: "none",
              background: `linear-gradient(135deg, ${COLORS.primary}, ${COLORS.primaryLight})`,
              color: "#fff", fontFamily: "'Playfair Display', serif", fontSize: 16, fontWeight: 700, cursor: "pointer"
            }}>Send a Message 💬</button>
            <button onClick={() => setShowMatch(false)} style={{
              marginTop: 10, width: "100%", padding: "12px", borderRadius: 14,
              border: `1.5px solid ${COLORS.border}`, background: "#fff",
              fontFamily: "Georgia, serif", fontSize: 15, color: COLORS.textMuted, cursor: "pointer"
            }}>Keep Discovering</button>
          </div>
        </div>
      )}
    </div>
  );
}

// ─── MATCHES SCREEN ──────────────────────────────────────────
function MatchesScreen({ onOpenChat }) {
  return (
    <div style={{ flex: 1, display: "flex", flexDirection: "column", background: COLORS.bg, overflowY: "auto" }}>
      <div style={{ padding: "16px 20px 8px" }}>
        <div style={{ fontFamily: "'Playfair Display', serif", fontSize: 22, fontWeight: 700, color: COLORS.text, marginBottom: 2 }}>Your Matches 💕</div>
        <div style={{ fontFamily: "Georgia, serif", fontSize: 13, color: COLORS.textMuted }}>{matches.length} people liked you back</div>
      </div>

      {/* New matches row */}
      <div style={{ padding: "12px 20px" }}>
        <div style={{ fontFamily: "Georgia, serif", fontSize: 12, color: COLORS.textMuted, textTransform: "uppercase", letterSpacing: "0.8px", marginBottom: 12 }}>New Matches</div>
        <div style={{ display: "flex", gap: 14, overflowX: "auto", paddingBottom: 4 }}>
          {matches.map(m => (
            <div key={m.id} onClick={() => onOpenChat(m)} style={{ textAlign: "center", cursor: "pointer", flexShrink: 0 }}>
              <div style={{ position: "relative", marginBottom: 6 }}>
                <Avatar profile={m} size={64} />
                {m.unread > 0 && (
                  <div style={{
                    position: "absolute", top: -2, right: -2, width: 20, height: 20,
                    background: COLORS.primary, borderRadius: "50%", border: "2px solid #fff",
                    display: "flex", alignItems: "center", justifyContent: "center",
                    fontFamily: "Georgia, serif", fontSize: 10, color: "#fff", fontWeight: 700
                  }}>{m.unread}</div>
                )}
              </div>
              <div style={{ fontFamily: "Georgia, serif", fontSize: 12, color: COLORS.text, fontWeight: 600 }}>{m.name}</div>
              <div style={{ fontFamily: "Georgia, serif", fontSize: 11, color: COLORS.primary }}>{m.matchPercent}% match</div>
            </div>
          ))}
        </div>
      </div>

      {/* Messages list */}
      <div style={{ padding: "8px 20px" }}>
        <div style={{ fontFamily: "Georgia, serif", fontSize: 12, color: COLORS.textMuted, textTransform: "uppercase", letterSpacing: "0.8px", marginBottom: 12 }}>Messages</div>
        {matches.map(m => (
          <div key={m.id} onClick={() => onOpenChat(m)} style={{
            display: "flex", alignItems: "center", gap: 14,
            padding: "14px 0", borderBottom: `1px solid ${COLORS.border}`, cursor: "pointer"
          }}>
            <Avatar profile={m} size={52} />
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 3 }}>
                <span style={{ fontFamily: "'Playfair Display', serif", fontSize: 16, fontWeight: 700, color: COLORS.text }}>{m.name}, {m.age}</span>
                <span style={{ fontFamily: "Georgia, serif", fontSize: 11, color: COLORS.textLight }}>{m.lastSeen}</span>
              </div>
              <div style={{ fontFamily: "Georgia, serif", fontSize: 13, color: m.unread ? COLORS.text : COLORS.textMuted, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", fontWeight: m.unread ? 600 : 400 }}>
                {m.unread ? `${m.unread} new message${m.unread > 1 ? "s" : ""} 💬` : "Tap to say hello! 👋"}
              </div>
            </div>
            {m.unread > 0 && (
              <div style={{
                width: 20, height: 20, background: COLORS.primary, borderRadius: "50%",
                display: "flex", alignItems: "center", justifyContent: "center",
                fontFamily: "Georgia, serif", fontSize: 10, color: "#fff", fontWeight: 700, flexShrink: 0
              }}>{m.unread}</div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

// ─── CHAT SCREEN ─────────────────────────────────────────────
function ChatScreen({ match, onBack }) {
  const [msgs, setMsgs] = useState(messages);
  const [input, setInput] = useState("");

  const send = () => {
    if (!input.trim()) return;
    setMsgs(m => [...m, { id: Date.now(), from: "me", text: input, time: "now" }]);
    setInput("");
    setTimeout(() => {
      setMsgs(m => [...m, { id: Date.now() + 1, from: "them", text: "That's so interesting! Tell me more 😊", time: "now" }]);
    }, 1200);
  };

  return (
    <div style={{ flex: 1, display: "flex", flexDirection: "column", background: COLORS.bg }}>
      {/* Header */}
      <div style={{
        display: "flex", alignItems: "center", gap: 12,
        padding: "14px 16px", background: "#fff",
        borderBottom: `1px solid ${COLORS.border}`,
        boxShadow: "0 2px 8px rgba(0,0,0,0.05)"
      }}>
        <button onClick={onBack} style={{ background: "none", border: "none", cursor: "pointer", color: COLORS.primary, fontSize: 20, padding: 4 }}>←</button>
        <Avatar profile={match} size={44} />
        <div style={{ flex: 1 }}>
          <div style={{ fontFamily: "'Playfair Display', serif", fontSize: 17, fontWeight: 700, color: COLORS.text }}>{match.name}</div>
          <div style={{ fontFamily: "Georgia, serif", fontSize: 12, color: match.online ? COLORS.online : COLORS.textLight }}>
            {match.online ? "● Online now" : `Last seen ${match.lastSeen}`}
          </div>
        </div>
        <div style={{ display: "flex", gap: 16 }}>
          <span style={{ fontSize: 20, cursor: "pointer" }}>📞</span>
          <span style={{ fontSize: 20, cursor: "pointer" }}>⋮</span>
        </div>
      </div>

      {/* Match banner */}
      <div style={{
        background: `linear-gradient(135deg, ${COLORS.surface}, #fff)`,
        padding: "12px 16px", textAlign: "center",
        borderBottom: `1px solid ${COLORS.border}`
      }}>
        <span style={{ fontSize: 16 }}>💕 </span>
        <span style={{ fontFamily: "Georgia, serif", fontSize: 13, color: COLORS.primary, fontWeight: 600 }}>You matched with {match.name}!</span>
        <span style={{ fontFamily: "Georgia, serif", fontSize: 13, color: COLORS.textMuted }}> · {match.matchPercent}% compatible</span>
      </div>

      {/* Messages */}
      <div style={{ flex: 1, overflowY: "auto", padding: "16px" }}>
        {msgs.map(msg => (
          <div key={msg.id} style={{
            display: "flex", justifyContent: msg.from === "me" ? "flex-end" : "flex-start",
            marginBottom: 10
          }}>
            {msg.from === "them" && <div style={{ marginRight: 8, marginTop: 4 }}><Avatar profile={match} size={28} /></div>}
            <div style={{ maxWidth: "72%" }}>
              <div style={{
                padding: "11px 15px", borderRadius: msg.from === "me" ? "18px 18px 4px 18px" : "18px 18px 18px 4px",
                background: msg.from === "me" ? `linear-gradient(135deg, ${COLORS.primary}, ${COLORS.primaryLight})` : "#fff",
                color: msg.from === "me" ? "#fff" : COLORS.text,
                fontFamily: "Georgia, serif", fontSize: 14, lineHeight: 1.5,
                boxShadow: msg.from === "me" ? "0 4px 12px rgba(196,86,58,0.25)" : "0 2px 8px rgba(0,0,0,0.06)"
              }}>{msg.text}</div>
              <div style={{ fontFamily: "Georgia, serif", fontSize: 10, color: COLORS.textLight, marginTop: 3, textAlign: msg.from === "me" ? "right" : "left" }}>{msg.time}</div>
            </div>
          </div>
        ))}
      </div>

      {/* Input */}
      <div style={{
        display: "flex", alignItems: "center", gap: 10,
        padding: "12px 16px", background: "#fff",
        borderTop: `1px solid ${COLORS.border}`
      }}>
        <span style={{ fontSize: 20, cursor: "pointer" }}>😊</span>
        <input
          value={input}
          onChange={e => setInput(e.target.value)}
          onKeyDown={e => e.key === "Enter" && send()}
          placeholder="Say something beautiful..."
          style={{
            flex: 1, padding: "12px 16px", borderRadius: 24,
            border: `1.5px solid ${COLORS.border}`, background: COLORS.surface,
            fontFamily: "Georgia, serif", fontSize: 14, color: COLORS.text,
            outline: "none"
          }}
        />
        <button onClick={send} style={{
          width: 44, height: 44, borderRadius: "50%", border: "none",
          background: input.trim() ? `linear-gradient(135deg, ${COLORS.primary}, ${COLORS.primaryLight})` : COLORS.border,
          display: "flex", alignItems: "center", justifyContent: "center",
          cursor: input.trim() ? "pointer" : "default",
          boxShadow: input.trim() ? "0 4px 12px rgba(196,86,58,0.3)" : "none",
          transition: "all 0.2s", color: "#fff"
        }}>
          <SendIcon size={16} />
        </button>
      </div>
    </div>
  );
}

// ─── PROFILE SCREEN ──────────────────────────────────────────
function ProfileScreen() {
  const me = { name: "You", age: 26, location: "Coventry, UK", bio: "Mixed heritage, curious soul. Love good food, better conversations, and long walks that go nowhere. Looking for someone real.", tags: ["Travel", "Music", "Cooking", "Art"], bg: `linear-gradient(135deg, ${COLORS.primary} 0%, #8B3A6B 100%)`, initials: "ME" };

  return (
    <div style={{ flex: 1, display: "flex", flexDirection: "column", background: COLORS.bg, overflowY: "auto" }}>
      {/* Hero */}
      <div style={{
        background: me.bg, padding: "48px 20px 32px", textAlign: "center", position: "relative"
      }}>
        <div style={{ fontFamily: "'Playfair Display', serif", fontSize: 72, color: "rgba(255,255,255,0.9)", fontWeight: 700, marginBottom: 12 }}>{me.initials}</div>
        <div style={{ fontFamily: "'Playfair Display', serif", fontSize: 24, fontWeight: 700, color: "#fff" }}>{me.name}, {me.age}</div>
        <div style={{ fontFamily: "Georgia, serif", fontSize: 13, color: "rgba(255,255,255,0.75)", marginTop: 4 }}>📍 {me.location}</div>
        <button style={{
          marginTop: 16, padding: "8px 20px", borderRadius: 20,
          border: "2px solid rgba(255,255,255,0.8)", background: "transparent",
          color: "#fff", fontFamily: "Georgia, serif", fontSize: 13, cursor: "pointer"
        }}>Edit Profile ✏️</button>
      </div>

      {/* Stats */}
      <div style={{ display: "flex", margin: "16px", gap: 10 }}>
        {[["12", "Matches"], ["48", "Likes"], ["3", "Chats"]].map(([n, l]) => (
          <div key={l} style={{
            flex: 1, background: "#fff", borderRadius: 16, padding: "16px 10px",
            textAlign: "center", border: `1.5px solid ${COLORS.border}`,
            boxShadow: "0 2px 8px rgba(0,0,0,0.04)"
          }}>
            <div style={{ fontFamily: "'Playfair Display', serif", fontSize: 24, fontWeight: 700, color: COLORS.primary }}>{n}</div>
            <div style={{ fontFamily: "Georgia, serif", fontSize: 12, color: COLORS.textMuted }}>{l}</div>
          </div>
        ))}
      </div>

      {/* Bio */}
      <div style={{ margin: "0 16px 16px", background: "#fff", borderRadius: 16, padding: 20, border: `1.5px solid ${COLORS.border}` }}>
        <div style={{ fontFamily: "Georgia, serif", fontSize: 12, color: COLORS.textMuted, textTransform: "uppercase", letterSpacing: "0.8px", marginBottom: 10 }}>About Me</div>
        <div style={{ fontFamily: "Georgia, serif", fontSize: 14, color: COLORS.text, lineHeight: 1.7 }}>{me.bio}</div>
      </div>

      {/* Tags */}
      <div style={{ margin: "0 16px 16px", background: "#fff", borderRadius: 16, padding: 20, border: `1.5px solid ${COLORS.border}` }}>
        <div style={{ fontFamily: "Georgia, serif", fontSize: 12, color: COLORS.textMuted, textTransform: "uppercase", letterSpacing: "0.8px", marginBottom: 12 }}>My Interests</div>
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
          {me.tags.map(t => (
            <span key={t} style={{
              padding: "8px 16px", borderRadius: 20,
              background: COLORS.surface, border: `1.5px solid ${COLORS.border}`,
              fontFamily: "Georgia, serif", fontSize: 13, color: COLORS.textMuted
            }}>#{t}</span>
          ))}
          <span style={{
            padding: "8px 16px", borderRadius: 20, border: `1.5px dashed ${COLORS.primary}`,
            fontFamily: "Georgia, serif", fontSize: 13, color: COLORS.primary, cursor: "pointer"
          }}>+ Add</span>
        </div>
      </div>

      {/* Settings */}
      <div style={{ margin: "0 16px 24px" }}>
        {[["🔔", "Notifications"], ["🔒", "Privacy Settings"], ["💳", "Upgrade to Premium"], ["🚪", "Sign Out"]].map(([icon, label]) => (
          <div key={label} style={{
            display: "flex", alignItems: "center", gap: 14,
            padding: "16px", background: "#fff", borderRadius: 14,
            border: `1.5px solid ${COLORS.border}`, marginBottom: 8, cursor: "pointer"
          }}>
            <span style={{ fontSize: 18 }}>{icon}</span>
            <span style={{ fontFamily: "Georgia, serif", fontSize: 15, color: label === "Sign Out" ? "#e74c3c" : COLORS.text, flex: 1 }}>{label}</span>
            <span style={{ color: COLORS.textLight, fontSize: 16 }}>›</span>
          </div>
        ))}
      </div>
    </div>
  );
}

// ─── NAV BAR ─────────────────────────────────────────────────
function NavBar({ tab, setTab }) {
  const tabs = [
    { id: "discover", icon: "🔍", label: "Discover" },
    { id: "matches", icon: "💕", label: "Matches" },
    { id: "chat", icon: "💬", label: "Messages" },
    { id: "profile", icon: "👤", label: "Profile" },
  ];
  return (
    <div style={{
      display: "flex", background: "#fff",
      borderTop: `1px solid ${COLORS.border}`,
      boxShadow: "0 -4px 16px rgba(0,0,0,0.06)"
    }}>
      {tabs.map(t => (
        <button key={t.id} onClick={() => setTab(t.id)} style={{
          flex: 1, padding: "10px 4px 12px", border: "none", background: "none",
          display: "flex", flexDirection: "column", alignItems: "center", gap: 3,
          cursor: "pointer"
        }}>
          <span style={{ fontSize: 20 }}>{t.icon}</span>
          <span style={{
            fontFamily: "Georgia, serif", fontSize: 10,
            color: tab === t.id ? COLORS.primary : COLORS.textLight,
            fontWeight: tab === t.id ? 700 : 400, letterSpacing: "0.3px"
          }}>{t.label}</span>
          {tab === t.id && <div style={{ width: 20, height: 2, background: COLORS.primary, borderRadius: 1 }} />}
        </button>
      ))}
    </div>
  );
}

// ─── ROOT APP ─────────────────────────────────────────────────
export default function App() {
  const [screen, setScreen] = useState("login");
  const [tab, setTab] = useState("discover");
  const [chatMatch, setChatMatch] = useState(null);

  const openChat = (match) => {
    setChatMatch(match);
    setTab("chatOpen");
  };

  return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "100vh", background: "#1a0a05", fontFamily: "Georgia, serif" }}>
      <link href="https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,700;1,400&display=swap" rel="stylesheet" />
      <div style={{
        width: 390, height: 844, background: COLORS.bg,
        borderRadius: 40, overflow: "hidden",
        boxShadow: "0 40px 120px rgba(0,0,0,0.6), 0 0 0 1px rgba(255,255,255,0.1)",
        display: "flex", flexDirection: "column", position: "relative"
      }}>
        {/* Status bar */}
        <div style={{
          background: screen === "login" || screen === "register" ? COLORS.primaryDark : "#fff",
          padding: "12px 24px 4px", display: "flex", justifyContent: "space-between", alignItems: "center"
        }}>
          <span style={{ fontFamily: "Georgia, serif", fontSize: 13, fontWeight: 700, color: screen === "login" || screen === "register" ? "#fff" : COLORS.text }}>9:41</span>
          <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
            {["▪▪▪", "WiFi", "🔋"].map(i => <span key={i} style={{ fontSize: 10, color: screen === "login" || screen === "register" ? "rgba(255,255,255,0.8)" : COLORS.textMuted }}>{i}</span>)}
          </div>
        </div>

        {/* Screen content */}
        {screen === "login" && <LoginScreen onLogin={() => setScreen("app")} goRegister={() => setScreen("register")} />}
        {screen === "register" && <RegisterScreen onRegister={() => setScreen("app")} goLogin={() => setScreen("login")} />}
        {screen === "app" && (
          <>
            <div style={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden" }}>
              {tab === "discover" && <DiscoverScreen />}
              {tab === "matches" && <MatchesScreen onOpenChat={openChat} />}
              {tab === "chatOpen" && chatMatch && <ChatScreen match={chatMatch} onBack={() => setTab("matches")} />}
              {tab === "chat" && <MatchesScreen onOpenChat={openChat} />}
              {tab === "profile" && <ProfileScreen />}
            </div>
            {tab !== "chatOpen" && <NavBar tab={tab} setTab={setTab} />}
          </>
        )}
      </div>
    </div>
  );
}